module.exports = __webpack_public_path__ + "media/img/payment-illustration-a291e3c6c48510267aec1f50b02b4f99.svg";